export default "__VITE_ASSET__Ctv6aUWI__"